export default class Formulas {
	// Formula 1
	static indiceMasaCorporal(pesoSeco, tallaM) {
		if (!pesoSeco || !tallaM) {
			return 0;
		}
		return (pesoSeco / tallaM ** 2).toFixed(2);
	}
	// Formula 2
	static interpretacionIMC(imc) {
		if (imc <= 18.4) {
			return "Bajo Peso";
		} else if (imc <= 24.9) {
			return "Normal";
		} else if (imc <= 29.9) {
			return "Sobrepeso";
		} else if (imc <= 35.4) {
			return "Obesidad I";
		} else if (imc <= 39.9) {
			return "Obesidad II";
		} else if (imc <= 60) {
			return "Obesidad III";
		}
		return "";
	}
	// Formula 3
	static ptgPesoHabitual(pesoSeco, pesoHabitual) {
		if (!pesoSeco || !pesoHabitual) {
			return null;
		}
		return ((pesoSeco / pesoHabitual) * 100).toFixed(2);
	}
	// Formula 4
	static interpretacionPesoHabitual(ptgPesoHabitual) {
		if (ptgPesoHabitual <= 89.9) {
			return "Desnutrición";
		} else if (ptgPesoHabitual <= 115) {
			return "Normal";
		} else if (ptgPesoHabitual <= 130) {
			return "Obesidad Leve";
		} else if (ptgPesoHabitual <= 150) {
			return "Obesidad Moderada";
		} else if (ptgPesoHabitual <= 300) {
			return "Obesidade Grave";
		}
		return "";
	}
	// Formula 5
	static ptgPerdidaPeso(pesoHabitualKg, pesoSeco) {
		return (((pesoHabitualKg - pesoSeco) / pesoHabitualKg) * 100).toFixed(
			2
		);
	}
	// Formula 6
	// Formula 7
	static ptgPesoIdeal(pesoSeco, pesoIdeal) {
		return ((pesoSeco / pesoIdeal) * 100).toFixed(2);
	}
	// Formula 8
	static interpretacionPesoIdeal(ptgPesoIdeal) {
		if (ptgPesoIdeal <= 70) {
			return "Desnutrición grave";
		} else if (ptgPesoIdeal <= 85) {
			return "Desnutrición moderada";
		} else if (ptgPesoIdeal <= 98) {
			return "Desnutrición leve";
		} else if (ptgPesoIdeal <= 115) {
			return "Normal";
		} else if (ptgPesoIdeal <= 130) {
			return "Exceso de peso";
		} else if (ptgPesoIdeal <= 150) {
			return "Obesidad moderada";
		} else if (ptgPesoIdeal <= 300) {
			return "Obesidad mórbida";
		}
		return "";
	}
	// Formula 9
	static pesoAjustadoLibreEdema(pesoSeco, pesoIdeal) {
		return (
			((parseFloat(pesoSeco) - parseFloat(pesoIdeal)) * 0.25) + parseFloat(pesoIdeal)
		).toFixed(2);
	}
	// Formula 10
	static indiceCinturaCadera(cinturaCm, caderaCm) {
		return (cinturaCm / caderaCm).toFixed(2);
	}
	// Formula 11
	static areaMuscularBrazoCorregida(
		circunferenciaBrazo,
		pliegueCutaneo,
		esHombre
	) {
		if (!circunferenciaBrazo || !pliegueCutaneo) return "";
		const factorSexo = esHombre ? 10 : 6.5;
		return (
			(circunferenciaBrazo - 3.1416 * pliegueCutaneo) ** 2 / 12.5664 -
			factorSexo
		).toFixed(2);
	}
	static factorEdad(edad) {
		return edad > 65 ? 1 : 0;
	}
	static factorSexo(esHombre) {
		return esHombre ? 1 : 0;
	}
	static factorActividadFisica(esHombre) {
		return esHombre ? 1.44 : 1.42;
	}
	// 12
	static percentilAMBC(edad, ambc, esHombre) {
		return esHombre
			? this.percentilAMBCHombre(edad, ambc)
			: this.percentilAMBCMujer(edad, ambc);
	}

	// 13
	static interpretacionAMBC(percentilAMBC) {
		if (!percentilAMBC) {
			return "";
		}
		if (percentilAMBC > 15) {
			return "Masa muscular promedio";
		} else if (percentilAMBC >= 5) {
			return "Depleción leve a moderada de tejido muscular";
		} else {
			return "Depleción severa de tejido muscular";
		}
	}

	// Formula 15
	static ecuacionVilar(edad, peso, talla, esHombre) {
		const GER =
			-2.497 * edad * this.factorEdad(esHombre) +
			0.011 * talla ** 2.023 +
			83.573 * peso ** 0.6291 +
			68.171 * this.factorSexo(esHombre);
		return (GER * this.factorActividadFisica(esHombre)).toFixed(2);
	}
	// Formula 16
	static kCal30(peso) {
		return peso * 30;
	}
	// Formula 17
	static kCal35(peso) {
		return peso * 35;
	}
	// 18
	static harrisBenedictGEB(peso, tallacm, edad, esHombre) {
		if (esHombre) {
			return 66 + 13.75 * peso + 5 * tallacm - 6.76 * edad;
		} else {
			return 655 + 9.56 * peso + 1.85 * tallacm - 4.68 * edad;
		}
	}
	// Formula 19
	static totalProteina(peso, proteinaDia) {
		if (!peso || !proteinaDia) return 0;
		return (peso * proteinaDia).toFixed(2);
	}
	// Formula 20
	static kcalProteina(proteina) {
		return proteina * 4;
	}
	// 21
	static ptgProteina(kcalProteina, recomendacionEnergia) {
		return ((kcalProteina * 100) / recomendacionEnergia).toFixed(2);
	}
	// 22
	static kcalHidratosCarbono(ptgHC, recomendacionEnergia) {
		return ((ptgHC / 100) * recomendacionEnergia).toFixed(2);
	}
	// 23
	static gramosHidratosCarbono(kcalHC) {
		return (kcalHC / 4).toFixed(2);
	}
	// 24
	static kcalLipidos(ptgLipidos, recomendacionEnergia) {
		return ((ptgLipidos / 100) * recomendacionEnergia).toFixed(2);
	}
	// 25
	static gramosLipidos(kcalLipidos) {
		return (kcalLipidos / 9).toFixed(2);
	}

	// 26
	static adecuacionAlimento(suma, recomendacion) {
		if (suma === null || recomendacion === null) {
			return 0;
		}
		return ((suma * 100) / recomendacion).toFixed(2);
	}

	// ptgLipidos
	static ptgLipidos(ptgProteinas, ptgHC) {
		return (100 - (parseFloat(ptgProteinas) + parseFloat(ptgHC))).toFixed(
			2
		);
	}

	static percentilAMBCHombre(edad, ambc) {
		if (edad >= 15 && edad <= 15.9) {
			if (ambc >= 0 && ambc <= 31.9) {
				return 5;
			}
			if (ambc >= 32 && ambc <= 34.9) {
				return 10;
			}
			if (ambc >= 35 && ambc <= 36.9) {
				return 15;
			}
			if (ambc >= 37 && ambc <= 40.3) {
				return 25;
			}
			if (ambc >= 40.4 && ambc <= 46.3) {
				return 50;
			}
			if (ambc >= 46.4 && ambc <= 53.1) {
				return 75;
			}
			if (ambc >= 53.3 && ambc <= 56.3) {
				return 85;
			}
			if (ambc >= 56.4 && ambc <= 65.7) {
				return 90;
			}
			if (ambc >= 65) {
				return 95;
			}
		}
		if (edad >= 16 && edad <= 16.9) {
			if (ambc >= 0 && ambc <= 37) {
				return 5;
			}
			if (ambc >= 37.1 && ambc <= 40.9) {
				return 10;
			}
			if (ambc >= 41 && ambc <= 42.4) {
				return 15;
			}
			if (ambc >= 42.5 && ambc <= 45.9) {
				return 25;
			}
			if (ambc >= 46 && ambc <= 51.9) {
				return 50;
			}
			if (ambc >= 52 && ambc <= 56.8) {
				return 75;
			}
			if (ambc >= 57.9 && ambc <= 63.6) {
				return 85;
			}
			if (ambc >= 63.7 && ambc <= 66.2) {
				return 90;
			}
			if (ambc >= 66.3) {
				return 95;
			}
		}
		if (edad >= 17 && edad <= 17.9) {
			if (ambc >= 0 && ambc <= 39.6) {
				return 5;
			}
			if (ambc >= 39.7 && ambc <= 42.6) {
				return 10;
			}
			if (ambc >= 42.7 && ambc <= 44.8) {
				return 15;
			}
			if (ambc >= 44.9 && ambc <= 48) {
				return 25;
			}
			if (ambc >= 48.1 && ambc <= 53.4) {
				return 50;
			}
			if (ambc >= 53.5 && ambc <= 60.4) {
				return 75;
			}
			if (ambc >= 60.5 && ambc <= 64.3) {
				return 85;
			}
			if (ambc >= 64.4 && ambc <= 67.9) {
				return 90;
			}
			if (ambc >= 68) {
				return 95;
			}
		}
		if (edad >= 18 && edad <= 24.9) {
			if (ambc >= 0 && ambc <= 34.4) {
				return 5;
			}
			if (ambc >= 34.5 && ambc <= 37.3) {
				return 10;
			}
			if (ambc >= 37.4 && ambc <= 39.6) {
				return 15;
			}
			if (ambc >= 39.7 && ambc <= 42.7) {
				return 25;
			}
			if (ambc >= 42.8 && ambc <= 49.4) {
				return 50;
			}
			if (ambc >= 49.5 && ambc <= 57.1) {
				return 75;
			}
			if (ambc >= 57.2 && ambc <= 61.8) {
				return 85;
			}
			if (ambc >= 61.9 && ambc <= 65) {
				return 90;
			}
			if (ambc >= 65) {
				return 95;
			}
		}
		if (edad >= 25 && edad <= 29.9) {
			if (ambc >= 0 && ambc <= 36.6) {
				return 5;
			}
			if (ambc >= 36.7 && ambc <= 39.9) {
				return 10;
			}
			if (ambc >= 40 && ambc <= 42.4) {
				return 15;
			}
			if (ambc >= 42.5 && ambc <= 46) {
				return 25;
			}
			if (ambc >= 46.1 && ambc <= 53) {
				return 50;
			}
			if (ambc >= 53.1 && ambc <= 61.4) {
				return 75;
			}
			if (ambc >= 61.5 && ambc <= 66.1) {
				return 85;
			}
			if (ambc >= 66.2 && ambc <= 68.9) {
				return 90;
			}
			if (ambc >= 69) {
				return 95;
			}
		}
		if (edad >= 30 && edad <= 34.9) {
			if (ambc >= 0 && ambc <= 37.9) {
				return 5;
			}
			if (ambc >= 38 && ambc <= 40.9) {
				return 10;
			}
			if (ambc >= 41 && ambc <= 43.4) {
				return 15;
			}
			if (ambc >= 43.5 && ambc <= 5 - 47.3) {
				return 25;
			}
			if (ambc >= 47.4 && ambc <= 4 - 54.4) {
				return 50;
			}
			if (ambc >= 54.5 && ambc <= 5 - 63.2) {
				return 75;
			}
			if (ambc >= 63.3 && ambc <= 3 - 67.6) {
				return 85;
			}
			if (ambc >= 67.7 && ambc <= 7 - 70.8) {
				return 90;
			}
			if (ambc >= 70.9 && ambc) {
				return 95;
			}
		}
		if (edad >= 35 && edad <= 39.9) {
			if (ambc >= 0 && ambc <= 38.5) {
				return 5;
			}
			if (ambc >= 38.6 && ambc <= 42.6) {
				return 10;
			}
			if (ambc >= 42.7 && ambc <= 44.6) {
				return 15;
			}
			if (ambc >= 44.7 && ambc <= 47.9) {
				return 25;
			}
			if (ambc >= 48 && ambc <= 55.3) {
				return 50;
			}
			if (ambc >= 55.4 && ambc <= 64) {
				return 75;
			}
			if (ambc >= 64.1 && ambc <= 69.1) {
				return 85;
			}
			if (ambc >= 69.2 && ambc <= 72.7) {
				return 90;
			}
			if (ambc >= 72.8) {
				return 95;
			}
		}
		if (edad >= 40 && edad <= 44.9) {
			if (ambc >= 0 && ambc <= 38.4) {
				return 5;
			}
			if (ambc >= 38.5 && ambc <= 42.1) {
				return 10;
			}
			if (ambc >= 42.2 && ambc <= 45.1) {
				return 15;
			}
			if (ambc >= 45.2 && ambc <= 48.7) {
				return 25;
			}
			if (ambc >= 48.8 && ambc <= 56) {
				return 50;
			}
			if (ambc >= 56.1 && ambc <= 64) {
				return 75;
			}
			if (ambc >= 64.1 && ambc <= 68.5) {
				return 85;
			}
			if (ambc >= 68.6 && ambc <= 71.6) {
				return 90;
			}
			if (ambc >= 71) {
				return 95;
			}
		}
		if (edad >= 45 && edad <= 49.9) {
			if (ambc >= 0 && ambc <= 37.7) {
				return 5;
			}
			if (ambc >= 37.8 && ambc <= 41.3) {
				return 10;
			}
			if (ambc >= 41.4 && ambc <= 43.7) {
				return 15;
			}
			if (ambc >= 43.8 && ambc <= 47.9) {
				return 25;
			}
			if (ambc >= 48 && ambc <= 55.2) {
				return 50;
			}
			if (ambc >= 55.3 && ambc <= 63.3) {
				return 75;
			}
			if (ambc >= 63.4 && ambc <= 68.4) {
				return 85;
			}
			if (ambc >= 68.5 && ambc <= 72.2) {
				return 90;
			}
			if (ambc >= 72.3) {
				return 95;
			}
		}
		if (edad >= 50 && edad <= 54.9) {
			if (ambc >= 0 && ambc <= 36) {
				return 5;
			}
			if (ambc >= 36.1 && ambc <= 40) {
				return 10;
			}
			if (ambc >= 40.1 && ambc <= 42.7) {
				return 15;
			}
			if (ambc >= 42.8 && ambc <= 46.6) {
				return 25;
			}
			if (ambc >= 46.7 && ambc <= 54) {
				return 50;
			}
			if (ambc >= 54.1 && ambc <= 62.7) {
				return 75;
			}
			if (ambc >= 62.8 && ambc <= 67) {
				return 85;
			}
			if (ambc >= 67.1 && ambc <= 70.4) {
				return 90;
			}
			if (ambc >= 70.5) {
				return 95;
			}
		}
		if (edad >= 55 && edad <= 59.9) {
			if (ambc >= 0 && ambc <= 36.5) {
				return 5;
			}
			if (ambc >= 36.6 && ambc <= 40.8) {
				return 10;
			}
			if (ambc >= 40.9 && ambc <= 42.7) {
				return 15;
			}
			if (ambc >= 42.8 && ambc <= 46.7) {
				return 25;
			}
			if (ambc >= 46.8 && ambc <= 54.3) {
				return 50;
			}
			if (ambc >= 54.4 && ambc <= 61.9) {
				return 75;
			}
			if (ambc >= 62 && ambc <= 66.4) {
				return 85;
			}
			if (ambc >= 66.5 && ambc <= 69.6) {
				return 90;
			}
			if (ambc >= 69.7) {
				return 95;
			}
		}
		if (edad >= 60 && edad <= 64.9) {
			if (ambc >= 0 && ambc <= 34.5) {
				return 5;
			}
			if (ambc >= 34.6 && ambc <= 38.7) {
				return 10;
			}
			if (ambc >= 38.8 && ambc <= 41.2) {
				return 15;
			}
			if (ambc >= 41.3 && ambc <= 44.9) {
				return 25;
			}
			if (ambc >= 45 && ambc <= 51.1) {
				return 50;
			}
			if (ambc >= 52.2 && ambc <= 60) {
				return 75;
			}
			if (ambc >= 60.1 && ambc <= 64.8) {
				return 85;
			}
			if (ambc >= 64.9 && ambc <= 67.5) {
				return 90;
			}
			if (ambc >= 67.6) {
				return 95;
			}
		}
		if (edad >= 65 && edad <= 69.9) {
			if (ambc >= 0 && ambc <= 31.4) {
				return 5;
			}
			if (ambc >= 31.5 && ambc <= 35.8) {
				return 10;
			}
			if (ambc >= 35.9 && ambc <= 38.4) {
				return 15;
			}
			if (ambc >= 38.5 && ambc <= 42.3) {
				return 25;
			}
			if (ambc >= 42.4 && ambc <= 49.1) {
				return 50;
			}
			if (ambc >= 49.2 && ambc <= 57.3) {
				return 75;
			}
			if (ambc >= 57.4 && ambc <= 61.2) {
				return 85;
			}
			if (ambc >= 61.3 && ambc <= 64.3) {
				return 90;
			}
			if (ambc >= 64.4) {
				return 95;
			}
		}
		if (edad >= 70 && edad <= 74.9) {
			if (ambc >= 0 && ambc <= 29.7) {
				return 5;
			}
			if (ambc >= 29.8 && ambc <= 33.8) {
				return 10;
			}
			if (ambc >= 33.9 && ambc <= 36.1) {
				return 15;
			}
			if (ambc >= 36.2 && ambc <= 40.2) {
				return 25;
			}
			if (ambc >= 40.3 && ambc <= 47) {
				return 50;
			}
			if (ambc >= 47.1 && ambc <= 54.6) {
				return 75;
			}
			if (ambc >= 54.7 && ambc <= 59.1) {
				return 85;
			}
			if (ambc >= 59.2 && ambc <= 62.1) {
				return 90;
			}
			if (ambc >= 62.2) {
				return 95;
			}
		}
	}

	static percentilAMBCMujer(edad, ambc) {
		if (edad >= 15 && edad <= 15.9) {
			if (ambc >= 0 && ambc <= 4) {
				return 5;
			}
			if (ambc >= 24.5 && ambc <= 25.8) {
				return 10;
			}
			if (ambc >= 25.9 && ambc <= 27.5) {
				return 15;
			}
			if (ambc >= 27.6 && ambc <= 29.2) {
				return 25;
			}
			if (ambc >= 29.3 && ambc <= 33) {
				return 50;
			}
			if (ambc >= 33.1 && ambc <= 37.3) {
				return 75;
			}
			if (ambc >= 37.4 && ambc <= 40.2) {
				return 85;
			}
			if (ambc >= 40.3 && ambc <= 41.7) {
				return 90;
			}
			if (ambc >= 41.8) {
				return 95;
			}
		}
		if (edad >= 16 && edad <= 16.9) {
			if (ambc >= 0 && ambc <= 25.2) {
				return 5;
			}
			if (ambc >= 25.3 && ambc <= 26.8) {
				return 10;
			}
			if (ambc >= 26.9 && ambc <= 28.2) {
				return 15;
			}
			if (ambc >= 28.3 && ambc <= 30) {
				return 25;
			}
			if (ambc >= 30.1 && ambc <= 33.6) {
				return 50;
			}
			if (ambc >= 33.7 && ambc <= 38) {
				return 75;
			}
			if (ambc >= 38.1 && ambc <= 40.2) {
				return 85;
			}
			if (ambc >= 40.3 && ambc <= 43.7) {
				return 90;
			}
			if (ambc >= 43.8) {
				return 95;
			}
		}
		if (edad >= 17 && edad <= 17.9) {
			if (ambc >= 0 && ambc <= 25.9) {
				return 5;
			}
			if (ambc >= 26 && ambc <= 27.5) {
				return 10;
			}
			if (ambc >= 27.6 && ambc <= 28.9) {
				return 15;
			}
			if (ambc >= 29 && ambc <= 30.7) {
				return 25;
			}
			if (ambc >= 30.8 && ambc <= 34.3) {
				return 50;
			}
			if (ambc >= 34.4 && ambc <= 39.6) {
				return 75;
			}
			if (ambc >= 39.7 && ambc <= 43.4) {
				return 85;
			}
			if (ambc >= 43.5 && ambc <= 46.2) {
				return 90;
			}
			if (ambc >= 46.3) {
				return 95;
			}
		}
		if (edad >= 18 && edad <= 24.9) {
			if (ambc >= 0 && ambc <= 19.5) {
				return 5;
			}
			if (ambc >= 19.6 && ambc <= 21.5) {
				return 10;
			}
			if (ambc >= 21.6 && ambc <= 22.8) {
				return 15;
			}
			if (ambc >= 22.9 && ambc <= 24.5) {
				return 25;
			}
			if (ambc >= 24.6 && ambc <= 28.3) {
				return 50;
			}
			if (ambc >= 28.4 && ambc <= 33.1) {
				return 75;
			}
			if (ambc >= 33.2 && ambc <= 36.4) {
				return 85;
			}
			if (ambc >= 36.5 && ambc <= 39) {
				return 90;
			}
			if (ambc >= 39.1) {
				return 95;
			}
		}
		if (edad >= 25 && edad <= 29.9) {
			if (ambc >= 0 && ambc <= 20.5) {
				return 5;
			}
			if (ambc >= 20.6 && ambc <= 21.9) {
				return 10;
			}
			if (ambc >= 22 && ambc <= 23.1) {
				return 15;
			}
			if (ambc >= 23.2 && ambc <= 25.2) {
				return 25;
			}
			if (ambc >= 25.3 && ambc <= 29.4) {
				return 50;
			}
			if (ambc >= 29.5 && ambc <= 34.9) {
				return 75;
			}
			if (ambc >= 35 && ambc <= 38.5) {
				return 85;
			}
			if (ambc >= 38.6 && ambc <= 41.9) {
				return 90;
			}
			if (ambc >= 42) {
				return 95;
			}
		}
		if (edad >= 30 && edad <= 34.9) {
			if (ambc >= 0 && ambc <= 21.1) {
				return 5;
			}
			if (ambc >= 21.2 && ambc <= 23) {
				return 10;
			}
			if (ambc >= 23.1 && ambc <= 24.2) {
				return 15;
			}
			if (ambc >= 24.3 && ambc <= 26.3) {
				return 25;
			}
			if (ambc >= 26.4 && ambc <= 30.9) {
				return 50;
			}
			if (ambc >= 31 && ambc <= 36.8) {
				return 75;
			}
			if (ambc >= 36.9 && ambc <= 41.2) {
				return 85;
			}
			if (ambc >= 41.3 && ambc <= 44.7) {
				return 90;
			}
			if (ambc >= 44.8) {
				return 95;
			}
		}
		if (edad >= 35 && edad <= 39.9) {
			if (ambc >= 0 && ambc <= 21.1) {
				return 5;
			}
			if (ambc >= 21.2 && ambc <= 23.4) {
				return 10;
			}
			if (ambc >= 23.5 && ambc <= 24.7) {
				return 15;
			}
			if (ambc >= 24.8 && ambc <= 27.3) {
				return 25;
			}
			if (ambc >= 27.4 && ambc <= 31.8) {
				return 50;
			}
			if (ambc >= 31.9 && ambc <= 38.7) {
				return 75;
			}
			if (ambc >= 38.8 && ambc <= 43.1) {
				return 85;
			}
			if (ambc >= 43.2 && ambc <= 46.1) {
				return 90;
			}
			if (ambc >= 46.2) {
				return 95;
			}
		}
		if (edad >= 40 && edad <= 44.9) {
			if (ambc >= 0 && ambc <= 21.3) {
				return 5;
			}
			if (ambc >= 21.4 && ambc <= 23.4) {
				return 10;
			}
			if (ambc >= 23.5 && ambc <= 25.5) {
				return 15;
			}
			if (ambc >= 25.6 && ambc <= 27.5) {
				return 25;
			}
			if (ambc >= 27.6 && ambc <= 32.3) {
				return 50;
			}
			if (ambc >= 32.4 && ambc <= 39.8) {
				return 75;
			}
			if (ambc >= 39.9 && ambc <= 45.8) {
				return 85;
			}
			if (ambc >= 45.9 && ambc <= 49.5) {
				return 90;
			}
			if (ambc >= 49.6) {
				return 95;
			}
		}
		if (edad >= 45 && edad <= 49.9) {
			if (ambc >= 0 && ambc <= 21.6) {
				return 5;
			}
			if (ambc >= 21.7 && ambc <= 23.1) {
				return 10;
			}
			if (ambc >= 23.2 && ambc <= 24.8) {
				return 15;
			}
			if (ambc >= 24.9 && ambc <= 27.4) {
				return 25;
			}
			if (ambc >= 27.5 && ambc <= 32.5) {
				return 50;
			}
			if (ambc >= 32.6 && ambc <= 39.5) {
				return 75;
			}
			if (ambc >= 40 && ambc <= 44.7) {
				return 85;
			}
			if (ambc >= 44.8 && ambc <= 48.4) {
				return 90;
			}
			if (ambc >= 48.5) {
				return 95;
			}
		}
		if (edad >= 50 && edad <= 54.9) {
			if (ambc >= 0 && ambc <= 22.2) {
				return 5;
			}
			if (ambc >= 22.3 && ambc <= 24.6) {
				return 10;
			}
			if (ambc >= 24.7 && ambc <= 25.7) {
				return 15;
			}
			if (ambc >= 25.8 && ambc <= 28.3) {
				return 25;
			}
			if (ambc >= 28.4 && ambc <= 33.4) {
				return 50;
			}
			if (ambc >= 33.5 && ambc <= 40.4) {
				return 75;
			}
			if (ambc >= 40.5 && ambc <= 46.1) {
				return 85;
			}
			if (ambc >= 46.2 && ambc <= 49.6) {
				return 90;
			}
			if (ambc >= 49.7) {
				return 95;
			}
		}
		if (edad >= 55 && edad <= 59.9) {
			if (ambc >= 0 && ambc <= 22.8) {
				return 5;
			}
			if (ambc >= 22.9 && ambc <= 24.8) {
				return 10;
			}
			if (ambc >= 24.9 && ambc <= 26.5) {
				return 15;
			}
			if (ambc >= 26.6 && ambc <= 28.7) {
				return 25;
			}
			if (ambc >= 28.8 && ambc <= 34.7) {
				return 50;
			}
			if (ambc >= 34.8 && ambc <= 42.3) {
				return 75;
			}
			if (ambc >= 42.4 && ambc <= 47.3) {
				return 85;
			}
			if (ambc >= 47.4 && ambc <= 52.1) {
				return 90;
			}
			if (ambc >= 52.2) {
				return 95;
			}
		}
		if (edad >= 60 && edad <= 64.9) {
			if (ambc >= 0 && ambc <= 22.4) {
				return 5;
			}
			if (ambc >= 22.5 && ambc <= 24.5) {
				return 10;
			}
			if (ambc >= 24.6 && ambc <= 26.3) {
				return 15;
			}
			if (ambc >= 26.4 && ambc <= 29.2) {
				return 25;
			}
			if (ambc >= 29.3 && ambc <= 34.5) {
				return 50;
			}
			if (ambc >= 34.6 && ambc <= 41.1) {
				return 75;
			}
			if (ambc >= 41.2 && ambc <= 45.6) {
				return 85;
			}
			if (ambc >= 45.7 && ambc <= 49.1) {
				return 90;
			}
			if (ambc >= 49.2) {
				return 95;
			}
		}
		if (edad >= 65 && edad <= 69.9) {
			if (ambc >= 0 && ambc <= 21.9) {
				return 5;
			}
			if (ambc >= 22 && ambc <= 24.5) {
				return 10;
			}
			if (ambc >= 24.6 && ambc <= 26.2) {
				return 15;
			}
			if (ambc >= 26.3 && ambc <= 28.9) {
				return 25;
			}
			if (ambc >= 29 && ambc <= 36.6) {
				return 50;
			}
			if (ambc >= 36.7 && ambc <= 41.6) {
				return 75;
			}
			if (ambc >= 41.7 && ambc <= 46.3) {
				return 85;
			}
			if (ambc >= 46.4 && ambc <= 49.6) {
				return 90;
			}
			if (ambc >= 49.7) {
				return 95;
			}
		}
		if (edad >= 70 && edad <= 74.9) {
			if (ambc >= 0 && ambc <= 22.2) {
				return 5;
			}
			if (ambc >= 22.3 && ambc <= 24.4) {
				return 10;
			}
			if (ambc >= 24.5 && ambc <= 26) {
				return 15;
			}
			if (ambc >= 26.1 && ambc <= 28.8) {
				return 25;
			}
			if (ambc >= 28.9 && ambc <= 34.3) {
				return 50;
			}
			if (ambc >= 29 && ambc <= 48.9) {
				return 75;
			}
			if (ambc >= 41.9 && ambc <= 46.4) {
				return 85;
			}
			if (ambc >= 46.5 && ambc <= 49.2) {
				return 90;
			}
			if (ambc >= 49.3) {
				return 95;
			}
		}
	}
}
